import { Component, inject, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { CurrencyService } from '../../core/services/currency.service';
import { Currency } from '../../shared/models/currency.model';

@Component({
  selector: 'app-currency-selector',
  imports: [MatMenuModule, MatButtonModule],
  templateUrl: './currency-selector.component.html',
  styleUrl: './currency-selector.component.css',
})
export class CurrencySelectorComponent implements OnInit, OnDestroy {
  private currencyService = inject(CurrencyService);

  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;

  currencies = [
    { key: 'EUR', name: 'Euro' },
    { key: 'USD', name: 'U.S Dollar' },
  ];

  selectedCurrency!: Currency;

  private scrollListener = () => {
    if (this.menuTrigger?.menuOpen) {
      this.menuTrigger.closeMenu();
    }
  };

  ngOnInit() {
    const currency = this.currencyService.currentCurrency();
    this.selectedCurrency =
      this.currencies.find((l) => l.key === currency) || this.currencies[0];

    window.addEventListener('scroll', this.scrollListener, true);
  }

  selectCurrency(currency: Currency) {
    this.selectedCurrency = currency;
    this.currencyService.setCurrency(currency.key);
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scrollListener, true);
  }
}
